import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'gen-histogram-chart',
  templateUrl: './histogram-chart.component.html',
  styleUrls: ['histogram-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class HistogramChartComponent implements OnInit {
  @Input() filter: any;
  public rangeFrom = 1;
  public rangeTo = 5;
  private isStatisticsPanelLoadedFirstTime: boolean;
  private data = [];
  private x;
  private y;
  private barchart;
  private z;
  private freqs;
  private x_axis;
  private y_axis;
  private freq;
  private brush;
  private brushg;
  private d3;
  private width = 372;
  private height = 116;
  private brushAverageStart = 0;
  private brushAverageEnd = 0;
  private rect;
  private b;
  private unit;

  constructor() {
  }

  private buildData() {
    let interval = 1;
    const step = this.filter.statistics.intervalStep;
    let currentAverage = 0;

    this.data.push({
      average: 0,
      frequency: 0,
      interval: 0,
      lb: 0,
      rb: this.filter.statistics &&
      this.filter.statistics.values &&
      this.filter.statistics.values.length > 0 ?
        this.filter.statistics.values[0].RB : 0
    });

    this.filter.statistics.values.forEach((value) => {
      if (value.interval === interval) {
        currentAverage = Math.ceil(value.averageRangeValue);
        this.data.push({
          average: Math.ceil(value.averageRangeValue),
          frequency: value.qty,
          interval: value.interval,
          lb: value.LB,
          rb: value.RB
        });
        interval += 1;
      } else {
        while (interval < value.interval) {
          const bounds = this.setBounds(this.data[interval - 2], step);
          this.data.push({
            average: Math.ceil(currentAverage + step),
            frequency: 0,
            interval: interval,
            lb: bounds.lb,
            rb: bounds.rb
          });
          currentAverage += step;
          interval++;

          if (interval === value.interval) {
            this.data.push({
              average: Math.ceil(value.averageRangeValue),
              frequency: value.qty,
              interval: value.interval,
              lb: value.LB,
              rb: value.RB
            });
            interval++;
          }
        }
      }
    });
  }

  private setBounds(item, step) {
    return {
      lb: item.lb + step,
      rb: item.rb + step
    };
  }

  ngOnInit() {
    this.data = [];
    this.buildData();
    this.isStatisticsPanelLoadedFirstTime = true;

    // this.isStatisticsPanel = true;
    if (this.isStatisticsPanelLoadedFirstTime) {
      this.isStatisticsPanelLoadedFirstTime = false;
      // @ts-ignore
      this.d3 = window.d3v3;


      this.unit = this.filter.config.unit ? this.filter.config.unit : '';

      // Scales
      this.x = this.d3.scale.ordinal().rangeRoundBands([0, this.width - 30], .1);
      this.y = this.d3.scale.linear().range([this.height, 0]);

      // Prepare the barchart canvas
      const size = document.getElementsByClassName('barchart').length;
      this.barchart = document.getElementsByClassName('barchart')[size - 1];


      this.barchart = this.d3.select(this.barchart)
        .attr('width', this.width) // '100%') - replaced with fixed size as per design request
        .attr('height', this.height + 34)
        .attr('y', this.height - this.height - 100)
        .append('g');

      this.z = this.d3.scale.ordinal().range(['#BFE2EC']);
      this.freqs = this.d3.layout.stack()(['frequency'].map((type) => {
        return this.data.map((d) => {
          return {
            x: d['average'],
            y: +d[type]
          };
        });
      }));

      this.x.domain(this.freqs[0].map((d) => {
        return d.x;
      }));
      this.y.domain([0, this.d3.max(this.freqs[this.freqs.length - 1], (d) => {
        return d.y;
      })]);

      // Axis variables for the bar chart
      this.x_axis = this.d3.svg.axis().scale(this.x).tickValues(this.x.domain().filter((d, i) => {
        return i !== 0 && (!(i % 7) || i === 1);
      })).orient('bottom');
      this.y_axis = this.d3.svg.axis().scale(this.y).orient('left').tickValues(this.getValues()).tickPadding(-1);

      // x axis
      this.barchart.append('g')
        .attr('class', 'x axis')
        .style('fill', '#000')
        .attr('transform', 'translate(22,' + (this.height) + ')')
        .call(this.x_axis)
        .select('.domain')
        .attr('d', 'M0,0V0H350V0');

      // y axis
      this.barchart.append('g')
        .attr('class', 'y axis')
        .style('fill', '#000')
        .attr('transform', 'translate(22,0)')
        .call(this.y_axis)
        .select('.domain')
        .attr('d', 'M 0,0H0V116H1');

      const brushAverageLeft = this.barchart.append('g');
      brushAverageLeft
        .attr('transform', 'translate(15,105)rotate(270)')
        .append('text')
        .attr('id', 'brushAverage')
        .classed('averageTextLeft ' + 'gen_' + this.filter.name, true)
        .text('# of aberrations')
        .attr('font-family', 'CentraleSans Book')
        .attr('font-size', '12px')
        .attr('fill', '#7f7f7f');


      const brushAverageBottom = this.barchart.append('g');
      brushAverageBottom
        .attr('transform', 'translate(22,143)')
        .append('text')
        .attr('id', 'brushAverageBottom')
        .classed('brushAverageBottom ' + 'gen_' + this.filter.name, true)
        .text(this.filter.displayName + ' value ' + this.unit)
        .attr('font-family', 'CentraleSans Book')
        .attr('font-size', '12px')
        .attr('fill', '#7f7f7f');


      // Add a group for each cause.
      this.freq = this.barchart.selectAll('g.freqq')
        .data(this.freqs)
        .enter().append('g')
        .attr('class', 'freqq ' + 'gen_' + this.filter.name)
        .attr('transform', 'translate(20,0)')
        .style('fill', (d, i) => {
          return this.z(i);
        });

      // Add a rect for each date.
      this.rect = this.freq.selectAll('rect')
        .data(Object)
        .enter().append('rect')
        .attr('class', 'bar')
        .attr('x', (d) => {
          return this.x(d.x);
        })
        .attr('y', (d) => {
          return this.y(d.y0) + this.y(d.y) - this.height;
        })
        .attr('height', (d) => {
          return this.height - this.y(d.y);
        })
        .attr('width', this.x.rangeBand())
        .attr('id', (d) => {
          return d['average'];
        });
      // Draw the brush
      this.brush = this.d3.svg.brush()
        .x(this.x)
        .on('brush', this.brushmove.bind(this))
        .on('brushend', this.brushend.bind(this));


      this.brushg = this.barchart.append('g')
        .attr('class', 'brush ' + 'gen_' + this.filter.name)
        .attr('transform', 'translate(29,0)')
        .call(this.brush);

      this.brushg.selectAll('rect')
        .attr('height', this.height);
      this.brushRange(this.filter.selectedValue.from, this.filter.selectedValue.to);
//       }

    }
  }

  private getValues() {
    const result = [];
    const max = Math.max.apply(Math, this.data.map((o) => {
      return o.frequency;
    }));
    const min = Math.min.apply(Math, this.data.map((o) => {
      return o.frequency;
    }));
    result.push(max);
    result.push(min);
    return result;
  }

  private brushmove() {
    this.y.domain(this.x.range()).range(this.x.domain());
    this.b = this.brush.extent();

    let localBrushAverageStart = (this.brush.empty()) ? this.brushAverageStart : Math.ceil(this.y(this.b[0])),
      localBrushAverageEnd = (this.brush.empty()) ? this.brushAverageEnd : Math.ceil(this.y(this.b[1]));

    // Snap to rect edge
    this.d3.select('g.brush.gen_' + this.filter.name).call((this.brush.empty()) ? this.brush.clear() : this.brush.extent([this.y.invert(localBrushAverageStart), this.y.invert(localBrushAverageEnd)]));

    this.d3.select('g.brush.gen_' + this.filter.name).select('.resize.e').select('rect').attr('width', 1.5).style('stroke', '#156096').style('visibility', 'visible');
    this.d3.select('g.brush.gen_' + this.filter.name).select('.resize.w').select('rect').attr('width', 1.5).style('stroke', '#156096').style('visibility', 'visible');

    // Fade all years in the histogram not within the brush
    this.d3.select('.freqq.gen_' + this.filter.name).selectAll('rect.bar').style('fill', (d, i) => {
      return this.data[i].lb >= localBrushAverageStart && this.data[i].rb <= localBrushAverageEnd || this.brush.empty() ? '#BFE2EC' : '#E3F2F6';
    });

    if (localBrushAverageStart < this.filter.statistics.minValue) {
      localBrushAverageStart = this.filter.statistics.minValue;
    }
    if (localBrushAverageEnd > this.filter.statistics.maxValue) {
      localBrushAverageEnd = this.filter.statistics.maxValue;
    }

    this.rangeFrom = localBrushAverageStart;
    this.rangeTo = localBrushAverageEnd;

  }

  private brushend() {
    let localBrushAverageStart = (this.brush.empty()) ? this.brushAverageStart : Math.ceil(this.y(this.b[0])),
      localBrushAverageEnd = (this.brush.empty()) ? this.brushAverageEnd : Math.floor(this.y(this.b[1]));

    this.d3.select('g.brush.gen_' + this.filter.name).select('.resize.e').select('rect').attr('width', 1.5).style('stroke', '#156096').style('visibility', 'visible');
    this.d3.select('g.brush.gen_' + this.filter.name).select('.resize.w').select('rect').attr('width', 1.5).style('stroke', '#156096').style('visibility', 'visible');


    this.d3.selectAll('.freqq.gen_' + this.filter.name).filter('rect.bar').style('fill', (d, i) => {
      return this.data[i].lb >= localBrushAverageStart && this.data[i].rb <= localBrushAverageEnd || this.brush.empty() ? '#BFE2EC' : '#E3F2F6';
    });

    if (localBrushAverageStart < this.filter.statistics.minValue) {
      localBrushAverageStart = this.filter.statistics.minValue;
    }
    if (localBrushAverageEnd > this.filter.statistics.maxValue) {
      localBrushAverageEnd = this.filter.statistics.maxValue;
    }

    this.rangeFrom = localBrushAverageStart;
    this.rangeTo = localBrushAverageEnd;
    this.setSelectedRange(localBrushAverageStart, localBrushAverageEnd);

  }

  private setSelectedRange(from, to) {
    if (!this.filter.statisticsSelectedValue) {
      this.filter.statisticsSelectedValue = { };
    }
    this.filter.statisticsSelectedValue.from = from;
    this.filter.statisticsSelectedValue.to = to;

    if (this.filter.selectedValue.from !== this.filter.statisticsSelectedValue.from) {
      if (this.filter.statisticsSelectedValue.from < this.filter.statistics.values[0].LB) {
        this.filter.selectedValue.from = this.filter.statistics.values[0].LB;
      }
      else {
        this.filter.selectedValue.from = this.filter.statisticsSelectedValue.from;
      }
    }

    if (this.filter.selectedValue.to !== this.filter.statisticsSelectedValue.to) {
      if (this.filter.statisticsSelectedValue.to > this.filter.statistics.values[this.filter.statistics.values.length - 1].RB) {
        this.filter.selectedValue.to = this.filter.statistics.values[this.filter.statistics.values.length - 1].RB;
      }
      else {
        this.filter.selectedValue.to = this.filter.statisticsSelectedValue.to;
    }
      }
  }

  private brushRange(from, to) {
    this.y.domain(this.x.domain()).range(this.x.range());
    let start, end;
    if (from && to) {
      start = this.y(from);
      end = this.y(to);
      this.brushg.call(this.brush.extent([start, end]))
        .call(this.brush.event);
    } else if (from && !to) {
      start = this.y(from);
      end = this.y(this.data[this.data.length - 1].rb);
      this.brushg.call(this.brush.extent([start, end]))
        .call(this.brush.event);
    } else if (!from && to) {
      start = this.y(this.data[0].lb);
      end = this.y(to);
      this.brushg.call(this.brush.extent([start, end]))
        .call(this.brush.event);
    } else if (!from && !to) {
      this.brushg.call(this.brush.clear());
      this.d3.select('.freqq.gen_' + this.filter.name).selectAll('rect.bar').style('fill', '#E3F2F6');
      this.rangeFrom = null;
      this.rangeTo = null;
    }
  }
}
